import React, { useContext } from 'react';

export const TenancyContext = React.createContext<string>("gastearsivi");

export default function useTenant(): string {
  const tenant = useContext(TenancyContext);
  return tenant;
}
